import * as React from 'react';
import { useEffect } from 'react';
import { Router, RouteComponentProps } from '@reach/router';
import RegistrationPage from './pages/RegistrationPage';
import NotFoundPage from './pages/NotFoundPage';
import SoftUpdatePage from './pages/SoftUpdatePage';
import MaintenancePage from './pages/MaintenancePage';
import InvalidPage from './pages/InvalidPage';
import Browser from '../utils/Browser';
import VerificationPage from './pages/verification';
import { Config } from '../config';

// VP-01c: root is decommissioned along with self-registration. nginx 302s
// "/" at the edge; this covers the paths that never reach it — /index.html,
// a cached service worker, and in-app navigation (the 404 page's
// back-to-home button calls navigate('/')). As a route it re-evaluates on
// client-side navigation, which a pathname read in Root's own render body
// cannot: Root sits above <Router> and does not re-render on navigation.
const LearnLoginRedirect: React.FC<RouteComponentProps> = (): null => {
  useEffect((): void => {
    window.location.replace(`${Config.learnUrl}/login`);
  }, []);

  return null;
};

const Root = (): React.ReactElement => {
  if (Browser.isIE()) {
    return (
      <MaintenancePage
        title={'noie.title'}
        content={'noie.content'}
        isIE={true}
      />
    );
  }

  return (
    <Router>
      <LearnLoginRedirect path="/" />
      <LearnLoginRedirect path="index.html" />
      {/* VP-01c: self-registration is decommissioned. The bare "signup" route
          rendered a fully open form (RegistrationPage coerces any unknown
          country code to 'id'), so only the invited school-code flow — which
          always arrives as /signup/<cc>?data=<payload> from educator-api —
          keeps a route. */}
      <RegistrationPage path="signup/:countryCode" />
      <SoftUpdatePage path="embed/update" />

      <VerificationPage path="verification" />
      <VerificationPage path="verification/:tokenId" />

      <MaintenancePage path="maintenance" />
      <InvalidPage path="invalid" />
      <NotFoundPage path="*" default />
    </Router>
  );
};

export default Root;
